import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './common/components';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('app')
);
